/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  width: 100%;

  .map-side {
    display: flex;
    border-left: 1px solid #e5e5e5;
    padding: 0 0.5%;

    .map {
      width: 50%;
      height: 640px;
    }
    .mapLeft {
      margin-right: 1px;
    }
    .mapRight {
      margin-left: 1px;
    }
  }
`;
 
export const LayoutOptions = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 8px;
`;

export const LayoutOption = styled.div`
  cursor: pointer;
  padding: 8px;
  border: 2px solid ${(props) => props.selected ? '#007bff' : '#ccc'};
  border-radius: 4px;
  background-color: ${(props) => props.selected ? '#f0f8ff' : '#fff'};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0056b3;
  }
`;

export const LayoutIcon = styled.div`
  width: ${(props) => props.horizontal ? '40px' : '30px'};
  height: ${(props) => props.horizontal ? '30px' : '40px'};
  border: 1px solid #666;
  display: flex;
  flex-direction: ${(props) => props.horizontal ? 'row' : 'column'};
`;

export const LayoutIconSection = styled.div`
  flex: 1;
  background-color: ${(props) => props.primary ? '#ddd' : '#eee'};
  border-right: ${(props) => props.horizontal && props.primary ? '1px solid #666' : 'none'};
  border-bottom: ${(props) => !props.horizontal && props.primary ? '1px solid #666' : 'none'};
`;

export const LayoutLabel = styled.span`
  font-size: 10px;
  margin-top: 4px;
`;

export const TwoMapsContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => props.layoutOrientation === 'horizontal' ? 'row' : 'column'};
  width: ${(props) => props.layoutOrientation === 'horizontal' ? 
    (props.gridCheck ? '637px' : '680px') : 
    (props.gridCheck ? '637px' : '680px')};
  height: ${(props) => props.layoutOrientation === 'horizontal' ? 
    (props.gridCheck ? '277px' : '320px') : 
    (props.gridCheck ? '597px' : '640px')};
  position: relative;
  margin: ${(props) => props.gridCheck ? '23px 0 0 23px' : '0'};
`;

export const MapContainer = styled.div`
  width: ${(props) => props.layoutOrientation === 'horizontal' ? 'calc(50% - 1px)' : '100%'};
  height: ${(props) => props.layoutOrientation === 'horizontal' ? '100%' : 'calc(50% - 1px)'};
  visibility: ${(props) => props.mapsReady ? 'visible' : 'hidden'};
  position: relative;
`;

export const MapSeparator = styled.div`
  width: ${(props) => props.layoutOrientation === 'horizontal' ? '2px' : '100%'};
  height: ${(props) => props.layoutOrientation === 'horizontal' ? '100%' : '2px'};
  background: linear-gradient(to ${(props) => props.layoutOrientation === 'horizontal' ? 'bottom' : 'right'}, #ccc 0%, #888 50%, #ccc 100%);
  position: relative;
  z-index: 1001;
  flex-shrink: 0;
`;

export const MapLabel = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(255,255,255,0.95);
  padding: 4px 8px;
  font-size: 12px;
  font-weight: bold;
  z-index: 1000;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

export const GridContainer = styled.div`
  position: absolute;
  z-index: 1001;
  pointer-events: none;
  
  ${(props) => props.type === 'vertical' && props.layoutOrientation === 'vertical' && `
    left: -23px;
    top: 0;
    height: 100%;
  `}
  
  ${(props) => props.type === 'vertical' && props.layoutOrientation === 'horizontal' && `
    left: -23px;
    top: 0;
    height: 100%;
  `}
  
  ${(props) => props.type === 'horizontal' && `
    bottom: -23px;
    left: 0;
    width: 100%;
  `}
`;

export const MapSideWithGrid = styled.div`
  width: 100%;
  border-left: 1px solid #e5e5e5;
  position: relative;
`;

export const ContainerMapWithGrid = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  position: relative;
`;